/**
 * i18n del checkout-widget: diccionarios planos, sin dependencias (plan 7.3.5).
 * El locale llega en el querystring que monta el SDK (`/session?pk=...&locale=...`).
 */
import { esCL } from './es-CL';
import { en } from './en';

export type Locale = 'es-CL' | 'en';

export type { MessageKey } from './es-CL';

export const DEFAULT_LOCALE: Locale = 'es-CL';

const DICTIONARIES: Record<Locale, Record<string, string>> = {
  'es-CL': esCL,
  en,
};

/** `{nombre}` en las plantillas; nada de HTML ni de expresiones. */
const PLACEHOLDER = /\{(\w+)\}/g;

/**
 * Resuelve el parametro `locale` del SDK a uno de los idiomas soportados.
 * Cualquier valor desconocido cae en es-CL, el idioma por defecto del hub.
 */
export function resolveLocale(raw: string | null | undefined): Locale {
  if (typeof raw !== 'string' || raw.length === 0) {
    return DEFAULT_LOCALE;
  }
  const normalized = raw.toLowerCase();
  if (normalized === 'es-cl' || normalized.startsWith('es')) {
    return 'es-CL';
  }
  if (normalized.startsWith('en')) {
    return 'en';
  }
  return DEFAULT_LOCALE;
}

function interpolate(template: string, vars: Record<string, string | number> | undefined): string {
  if (vars === undefined) {
    return template;
  }
  return template.replace(PLACEHOLDER, (match: string, name: string): string => {
    const value = vars[name];
    return value === undefined ? match : String(value);
  });
}

/**
 * Traduce una clave. Si falta en el idioma pedido cae a es-CL, y si tampoco existe
 * devuelve la propia clave: nunca lanza ni deja la UI en blanco.
 */
export function t(
  locale: Locale,
  key: string,
  vars?: Record<string, string | number> | undefined,
): string {
  const dictionary = DICTIONARIES[locale];
  const template = dictionary[key] ?? DICTIONARIES[DEFAULT_LOCALE][key] ?? key;
  return interpolate(template, vars);
}
